// {
//   "type": "FeatureCollection",
//   "totalFeatures": 1,
//   "features": [
//     {
//       "type": "Feature",
//       "id": "LinhasAtuaisEFuturas.133",
//       "geometry": {
//         "type": "MultiLineString",
//         "coordinates": [
//           [
//             [
//               -46.697305,
//               -23.827399
//             ],
//             [
//               -46.697363,
//               -23.827409
//             ],
//             [
//               -46.697422,
//               -23.827394

type PathResponse = {
	type: string;
	totalFeatures: number;
	features: {
		type: string;
		id: string;
		geometry: {
			type: string;
			coordinates: number[][][];
		};
	}[];
};

export type Coordinate = [number, number];

export default async function getPath(lineName: string, direction: number) {
	const url = `/api-path/?lineName=${lineName}&direction=${direction}`;

	const response = await fetch(encodeURI(url), {
		headers: { 'Content-Type': 'application/json' },
	});

	const data = await response.json();

	const rawCoordinates = data.features[0]?.geometry.coordinates[0] ?? [];

	const coordinates: Coordinate[] = rawCoordinates.map((coord: number[]) => [
		coord[1],
		coord[0],
	]);
	return coordinates;
}
